"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var edgeStyle = function edgeStyle(kind, data, edgeSizeMap) {
  if (typeof data === 'string') {
    return "\n      ".concat(kind, ": ").concat(edgeSizeMap[data] || data, ";\n    ");
  }

  var result = [];

  if (data.horizontal) {
    result.push("\n      ".concat(kind, "-left: ").concat(edgeSizeMap[data.horizontal] || data.horizontal, ";\n      ").concat(kind, "-right: ").concat(edgeSizeMap[data.horizontal] || data.horizontal, ";\n    "));
  }

  if (data.vertical) {
    result.push("\n      ".concat(kind, "-top: ").concat(edgeSizeMap[data.vertical] || data.vertical, ";\n      ").concat(kind, "-bottom: ").concat(edgeSizeMap[data.vertical] || data.vertical, ";\n    "));
  }

  if (data.top) {
    result.push("\n      ".concat(kind, "-top: ").concat(edgeSizeMap[data.top] || data.top, ";\n\n    "));
  }

  if (data.bottom) {
    result.push("\n      ".concat(kind, "-bottom: ").concat(edgeSizeMap[data.bottom] || data.bottom, ";\n\n    "));
  }

  if (data.left) {
    result.push("\n      ".concat(kind, "-left: ").concat(edgeSizeMap[data.left] || data.left, ";\n    "));
  }

  if (data.right) {
    result.push("\n      ".concat(kind, "-right: ").concat(edgeSizeMap[data.right] || data.right, ";\n      "));
  }

  return result;
};

var _default = edgeStyle;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/utils/edgeStyle.js
// module id = 690
// module chunks = 0 15 16 17 18